/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Event from 'ui/components/cards/Event.vue';
import WorkspaceTemplate from 'ui/components/cards/WorkspaceTemplate.vue';
import Webinar from 'ui/components/cards/Webinar.vue';
import WebinarTemplate from 'ui/components/cards/WebinarTemplate.vue';
import ConnectedEvent from 'content-hub/components/cards/ConnectedEvent.vue';

/**
 * This component renders the list of the given workspaces.
 *
 * @vue-prop {Object[]} workspaces the list of workspaces to list
 * @vue-prop {'Event'|'Template'} mode whether to render events or templates
 * @vue-prop {String} [uidPrefix='wks'] an optional prefix to use for UUID prefixing (used for appcues targeting)
 * @vue-prop {String[]} [selection] an optional list of workspace to mark as 'selected'
 *
 * @category ui.components
 * @exports WorkspacesList
 */
const __vue_script__ = {
    name: 'WorkspacesList',

    components: {
        ConnectedEvent,
        Event,
        WorkspaceTemplate,
        Webinar,
        WebinarTemplate
    },

    props: {
        workspaces: {
            type: Array,
            required: true
        },

        mode: {
            type: String,
            default: 'Event',
            validator: value => ['ConnectedEvent', 'Event', 'WorkspaceTemplate', 'Webinar', 'WebinarTemplate'].includes(value)
        },

        uidPrefix: {
            type: String,
            default: 'wks'
        },

        selection: {
            type: Array,
            default: () => []
        },

        highlightArchived: {
            type: Boolean,
            default: false
        },

        selectable: {
            type: Boolean,
            default: false
        },
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "workspaces-list" },
    [
      _vm._t("default"),
      _c(
        "div",
        {
          staticClass: "workspaces-wrapper",
          class: { "listing-grid": _vm.mode !== "ConnectedEvent" },
        },
        _vm._l(_vm.workspaces, function (workspace) {
          return _c(_vm.mode, {
            key: workspace._id || workspace.id,
            tag: "component",
            staticClass: "listing-item",
            class: {
              archived:
                _vm.highlightArchived &&
                workspace.lifecycle.stage === "archived",
            },
            attrs: {
              workspace: workspace,
              "uid-prefix": _vm.uidPrefix,
              selectable: _vm.selectable,
              selected: _vm.selection.includes(workspace._id || workspace.id),
            },
            on: {
              click: function ($event) {
                return _vm.$emit("click", workspace, $event)
              },
            },
          })
        }),
        1
      ),
    ],
    2
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/WorkspacesList.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__